export default {
	/**
	 * @param {*要判断的参数值} value
	 * 是否是数值
	 */
	isNumber(value) {
		let reg = new RegExp('^[0-9]*$')
		return reg.test(value)
	},
	/**
	 *
	 * @param {*要判断的参数值} value
	 * 是否是邮箱
	 */
	isEmail(value) {
		var reg = /\b[\w.%+-]+@[\w.-]+\.[a-zA-Z]{2,6}\b/
		return reg.test(value)
	}
}



// WEBPACK FOOTER //
// ./src/util/validator.js